import React from "react";
import { useTranslation } from "react-i18next";

const OrderSuccessModal = () => {
  const { t } = useTranslation();
  return (
    <div
      className="modal login-modal modal-light fade"
      id="Request-Sent-Modal"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body py-5">
            <div className="md-body text-center">
              <div className="icon-box mb-3">
                <svg
                  width="100"
                  height="104"
                  viewBox="0 0 100 104"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M50 1.625C22.379 1.625 0 24.1719 0 52C0 79.8281 22.379 102.375 50 102.375C77.621 102.375 100 79.8281 100 52C100 24.1719 77.621 1.625 50 1.625ZM50 92.625C27.7621 92.625 9.67742 74.4047 9.67742 52C9.67742 29.5953 27.7621 11.375 50 11.375C72.2379 11.375 90.3226 29.5953 90.3226 52C90.3226 74.4047 72.2379 92.625 50 92.625ZM33.871 48.75C37.4395 48.75 40.3226 45.8453 40.3226 42.25C40.3226 38.6547 37.4395 35.75 33.871 35.75C30.3024 35.75 27.4194 38.6547 27.4194 42.25C27.4194 45.8453 30.3024 48.75 33.871 48.75ZM66.129 48.75C69.6976 48.75 72.5806 45.8453 72.5806 42.25C72.5806 38.6547 69.6976 35.75 66.129 35.75C62.5605 35.75 59.6774 38.6547 59.6774 42.25C59.6774 45.8453 62.5605 48.75 66.129 48.75ZM66.9355 63.4969C62.7419 68.575 56.5524 71.5 50 71.5C43.4476 71.5 37.2581 68.5953 33.0645 63.4969C31.3508 61.425 28.2863 61.1609 26.25 62.8672C24.1935 64.5938 23.9315 67.6609 25.625 69.7328C31.6734 77.0453 40.5645 81.2297 50 81.2297C59.4355 81.2297 68.3266 77.0453 74.375 69.7328C76.0887 67.6609 75.8064 64.5938 73.75 62.8672C71.7137 61.1609 68.6492 61.425 66.9355 63.4969Z"
                    fill="#198855"
                  />
                </svg>
              </div>
              <div className="modal-logo-div mb-4">
                <h4 className="text-success">
                  <b>{t("orderSuccess.title")}</b>
                </h4>
              </div>
              <p>{t("orderSuccess.description")}</p>
              <p>{t("orderSuccess.thankYou")}</p>
              <div className="back-btn-div">
                <a className="btn btn-primary py-3 px-4" href="/">
                  {t("orderSuccess.backToHome")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessModal;
